import { useState, useEffect } from 'react';
import { Header, Singolo, Tabs, Timer } from "../../Components";
import { GrClose, GrRefresh } from 'react-icons/gr';
import { AiOutlineEye, AiOutlineCheck } from 'react-icons/ai';
import { List } from '../../utils/constants';
import ProgressBar from '../../Components/ProgressBar/ProgressBar';

const Singolo_Astice_1 = (props) => {
    const { setDificolta, setAvvia, setGiocatori, setMultipleDifficolta, setChampion, setLoss } = props;
    const [isClicked, setIsClicked] = useState(false);
    const [isClose, setIsClose] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [showText, setShowText] = useState(false);
    const [showCheckIcon, setShowCheckIcon] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [timeUp, setTimeUp] = useState(false);
    const [restartTimer, setRestartTimer] = useState(false);
    const [progressKey, setProgressKey] = useState(0);

    const [item, setItem] = useState(() => {
        const randomIndex = Math.floor(Math.random() * List.length);
        return List[randomIndex];
    });

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsVisible(!document.hidden);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const handleEyeClick = () => {
        setShowText(!showText);
        setShowCheckIcon(true);
    };


    const handleNextClick = () => {
        setShowCheckIcon(false);
        setShowText(false);
        const nextIndex = (currentIndex + 1) % item.length;
        setCurrentIndex(nextIndex);
        setIsClicked(true);
        setIsClose(false);
        setTimeUp(false);
        setProgressKey(prevKey => prevKey + 1);

        if (nextIndex === 0) {
            localStorage.removeItem('selectedTime');
            localStorage.removeItem('selectedSecond');
            setChampion(true);
            setDificolta(false);
            setAvvia(false);
        }

        setTimeout(() => {
            setIsClicked(false);
          
        }, 500);
    };

    const cancelClick = () => {
        setCurrentIndex(0)
        setShowCheckIcon(false);
        setShowText(false);
        setTimeUp(false)
        setIsClicked(false);
        setIsClose(true)
        setProgressKey(prevKey => prevKey + 1)

        
    }
    const handleRefreshClick = () => {
        // setCurrentIndex(0);
        // setShowCheckIcon(false);
        setGiocatori(false)
        setDificolta(false)
        setAvvia(false)
        localStorage.removeItem('selectedTime');
        localStorage.removeItem('selectedSecond');
        setShowText(false);
        setTimeUp(false);
        setRestartTimer((prevRestartTimer) => !prevRestartTimer);
    };
    const Back = () => {
        setDificolta(false);
        setAvvia(false);
        localStorage.removeItem('selectedTime');
        localStorage.removeItem('selectedSecond');
    };

    useEffect(() => {
        if (timeUp) {
            cancelClick();
        }
    }, [timeUp]);
    console.log(item);

    return (
        <>
            <div>
                <div>
                    <Header icon1={<GrClose className='header_icon' onClick={Back} />} icon2={<GrRefresh className='header_icon' onClick={handleRefreshClick} />} />
                </div>
                <div className="main_div2">
                    <div className="singolo_div">
                        <div>
                            <div className="tabs_main_div">
                                {item.map((_, index) => (
                                    <div key={index} className={`tabs_inner_div ${currentIndex >= index ? 'tabs_div' : ''}`} />
                                ))}
                            </div>
                        </div>



                        <div className={`animationContainer animate__animated ${isClicked ? 'animate__slideInRight faster-animation' : ''} ${isClose ? 'animate__slideInLeft faster-animation' : ''}`}>

                            <div className="singolo_inner_div1">{currentIndex + 1}</div>
                            <div className="singolo_inner_div2">{item[currentIndex].domanda}</div>
                            <div className={`singolo_inner_div3 ${showText ? 'clear-text' : 'blur-text'}`}>
                                {item[currentIndex].risposta}
                            </div>

                            <div className={!timeUp ? "singolo_inner_div4" : "singolo_inner_div5"}>
                                {!timeUp ? (
                                    <div className="singolo_icon_div">
                                        <GrClose className="singolo_icon" onClick={cancelClick} />
                                    </div>
                                ) : null}
                                {!timeUp ? (
                                    showCheckIcon ? (
                                        <div className="singolo_icon_main_div" onClick={handleNextClick}>
                                            <ProgressBar setTimeUp={setTimeUp} key={progressKey}
                                                isVisible={isVisible}
                                            />
                                            <div className="singolo_icon_div2">
                                                <AiOutlineCheck className="singolo_icon" onClick={() => setIsClicked(true)} />

                                            </div>
                                        </div>
                                    ) : (
                                        <div className="singolo_icon_main_div" onClick={handleEyeClick}>
                                                <ProgressBar setTimeUp={setTimeUp} key={progressKey}
                                                    isVisible={isVisible}
                                                />
                                            <div className="singolo_icon_div2">
                                                <AiOutlineEye className="singolo_icon" />
                                            </div>
                                        </div>
                                    )
                                ) : null}
                            </div>

                        </div>
                        <div className='timer_main_div'>
                            <Timer key={restartTimer ? 'restart' : 'no-restart'} restart={restartTimer}
                                setGiocatori={setGiocatori}
                                setDificolta={setDificolta}
                                setMultipleDifficolta={setMultipleDifficolta}
                                setAvvia={setAvvia}
                                setLoss={setLoss}

                            />
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default Singolo_Astice_1;
